import React, { useRef } from "react";
import { IonModal, IonContent } from "@ionic/react";
import { useSelector } from "react-redux";
import { actions } from "../../Redux/store";
import appUpdate from "../../assets/imgs/app-update.svg";
import { Capacitor } from "@capacitor/core";
import { AppUpdate } from "@capawesome/capacitor-app-update";
import { hapticsImpactLight } from "../../lib/utils";

export default function AppUpdateModal() {
  const modal = useRef<HTMLIonModalElement>(null);
  const isOpen = useSelector((sate: any) => sate.modal.AppUpdateModal?.open);
  const toggle = () => {
    actions.modal.closeAppUpdateModal(null);
  };

  function dismiss() {
    modal.current?.dismiss();
    toggle();
  }

  const handleUpdateNow = async () => {
    const platform = Capacitor.getPlatform();
    hapticsImpactLight();
    if (platform === "ios") {
      window.open(
        "https://apps.apple.com/app/6502530085",
        "_system",
      );
    } else if (platform === "android") {
      try {
        await AppUpdate.performImmediateUpdate();
      } catch (error) {
        console.error("Error performing android update:", error);
      }
      dismiss();
    }
  };

  return (
    <IonModal
      onDidDismiss={dismiss}
      className="app-update-modal"
      isOpen={isOpen}
      backdropDismiss={false}
      ref={modal}
      initialBreakpoint={0.5}
    >
      <>
        <IonContent>
          <div className="flex flex-col items-center justify-center w-full p-5 pt-6 text-center">
            <p className="text-white text-[20px] font-medium">
              We’ve been cooking recently...
            </p>

            <p className="text-white/60 font-medium text-[12px] pt-1">
              Update to get the newest version of our app.
            </p>

            <div className="mt-6">
              <img src={appUpdate} alt="appUpdate" />
            </div>
          </div>

          <div
            className="bg-[#000513] flex items-center justify-center px-5 mt-2"
            style={{
              paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
            }}
          >
            <button
              className="w-[280px] h-[48px] flex justify-center items-center bg-white/15 rounded-[50px]"
              onClick={handleUpdateNow}
            >
              <span className="text-[12px] font-medium text-white">
                Update Now
              </span>
            </button>
          </div>
        </IonContent>
      </>
    </IonModal>
  );
}
